import React from 'react';
import { connect } from 'react-redux';
import universal from 'react-universal-component';
import Loading from './Loading';
import NotFound from './NotFound';
import isLoading from '../../selectors/isLoading';

import { topOfPage } from '../../utils';

const UniversalComponent = universal(({ page }) => import(`../${page}`), {
  minDelay: 500,
  loading: Loading,
  error: NotFound,
});

const Switcher = ({ page, isLoading }) => {
  topOfPage();
  return <UniversalComponent page={page} isLoading={isLoading} />;
};

const mapState = (state) => {
  const { location, page, direction } = state;
  const { pathname } = location;
  return {
    pathname,
    page,
    direction,
    isLoading: isLoading(state),
  };
};

export default connect(mapState)(Switcher);
